import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  dialogContainer: {
    borderRadius: 8,
    backgroundColor: theme.palette.yellow.lighter,
    padding: theme.spacing(4),
    position: "relative",
  },
  loadingContainer: {
    borderRadius: 8,
    backgroundColor: theme.palette.yellow.lighter,
    padding: theme.spacing(4),
    position: "relative",
    height: "300px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: "1 1 0",
  },
  dialogContent: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    background: theme.palette.common.white,
    borderRadius: 8,
  },
  sectionContent: {
    marginTop: theme.spacing(2),
    maxHeight: "400px",
    overflow: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  progressBarContainer: {
    display: "flex",
    height: "8px",
    borderRadius: 8,
    overflow: "hidden",
    backgroundColor: "#eee",
  },
  absoluteTopRight: {
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(2),
  },
  progressBarSegmentPrimary: {
    backgroundColor: theme.palette.primary.main,
  },
  progressBarSegmentRed: {
    backgroundColor: theme.palette.red.light,
  },
  progressBarSegmentYellow: {
    backgroundColor: theme.palette.yellow.light,
  },
}));
